import { HippotherapyPageContent } from './components/hippotherapy-page-content/HippotherapyPageContent';

export const HippotherapyPageAdmin = () => {
    return <HippotherapyPageContent />;
};
